import { useEffect, useState } from 'react';
import { api } from './api';
import type { OrderOut } from './types';

const KEY = 'gise.tickets';
export function savedOrders(): Record<string, OrderOut> {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}');
  } catch {
    return {};
  }
}
/** "Cüzdana ekle": keep the full ticket (incl. signed QR) on this device so it opens offline at the door. */
export function saveOrderOffline(o: OrderOut) {
  try {
    const all = savedOrders();
    all[o.id] = o;
    localStorage.setItem(KEY, JSON.stringify(all));
    return true;
  } catch {
    return false;
  }
}

export function useOrder(id: string, k: string | null) {
  const [order, setOrder] = useState<OrderOut | null>(null);
  const [error, setError] = useState<number | null>(null);
  const [offline, setOffline] = useState(false);
  useEffect(() => {
    api<OrderOut>(`/orders/${id}${k ? `?k=${encodeURIComponent(k)}` : ''}`).then(
      (o) => {
        setOrder(o);
        if (savedOrders()[o.id]) saveOrderOffline(o);
      },
      (e) => {
        const s = savedOrders()[id];
        if (s) {
          setOrder(s);
          setOffline(true);
        } else setError(e.status || 0);
      },
    );
  }, [id, k]);
  return { order, error, offline };
}

export function icsFor(o: OrderOut) {
  const dt = (ms: number) => new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  const start = o.session.startsAt;
  const body = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Gise//TR',
    'BEGIN:VEVENT',
    `UID:${o.id}@gise.melihkizmaz.dev`,
    `DTSTAMP:${dt(Date.now())}`,
    `DTSTART:${dt(start)}`,
    `DTEND:${dt(start + 2 * 3600_000)}`,
    `SUMMARY:${o.event.title} — ${o.venue.name}`,
    `LOCATION:${o.venue.name}\\, ${o.venue.addr.replace(/,/g, '\\,')}`,
    `DESCRIPTION:${o.no} · ${o.tickets.length} bilet`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([body], { type: 'text/calendar' }));
  a.download = `${o.no}.ics`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 5000);
}
